import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

// -------------------- FETCH BOOKLET DETAIL --------------------
export const fetchBookletDetail = createAsyncThunk(
  "booklet/fetchDetail",
  async ({ stateId, districtId }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/booklet/detail`, { stateId, districtId });
      return res.data.data; // booklet, pages, bookings
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load booklet");
    }
  }
);

// -------------------- BOOK SLOTS --------------------
export const bookBookletSlots = createAsyncThunk(
  "booklet/bookSlots",
  async ({ bookletId, slots, businessName, contactNumber, email }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/booklet/book-slots`, {
        bookletId,
        slots,
        businessName,
        contactNumber,
        email
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to book slots");
    }
  }
);

// -------------------- FETCH MERCHANT'S CAM BOOKINGS --------------------
export const fetchMerchantCamBookings = createAsyncThunk(
  "booklet/fetchMerchantCamBookings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/booklet/my-bookings`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch CAM bookings");
    }
  }
);
